module.exports = __webpack_public_path__ + "static/media/7.faf45214.png";